<template>
	<q-card
		:dark="isMobile"
		:class="isMobile ? 'bg-black q-pt-md' : 'bg-white'"
		:style="isMobile ? '' : 'min-width: 80vw; min-height: 80vh; max-height: 80vh;'"
	>
		<q-toolbar :class="isMobile ? 'text-white q-px-md' : ''">
			<q-toolbar-title>{{ $t('statement') }}</q-toolbar-title>

			<q-btn @click="close_modal" flat round dense icon="fal fa-times" v-close-popup />
		</q-toolbar>

		<q-card-section>
			<div :class="isMobile ? 'bg-black' : 'bg-white'">
				<q-tabs
					v-model="tab"
					align="justify"
					:class="isMobile ? 'bg-black' : 'bg-white'"
					:active-bg-color="isMobile ? 'bg-black' : 'bg-white'"
					:indicator-color="isMobile ? 'white' : 'black'"
					@update:model-value="changeTab()"
				>
					<q-tab v-if="hasCourses" name="group_trainings" :label="$t(titleCourses)" />
					<!-- <q-tab v-if="hasTrails" name="trails" :label="$t(titleTrails)" /> -->
					<q-tab v-if="hasPresentials" name="presential_events" :label="$t(titlePresentials)" />
					<q-tab v-if="hasLiveClasses" name="live_classes" :label="$t(titleLiveClasses)" />
					<q-tab v-if="hasWebinars" name="webcasts" :label="$t(titleWebinars)" />
					<q-tab v-if="hasDrills" name="drills" :label="$t(titleDrills)" />
					<q-tab name="surveys" :label="$t('surveys')" />
				</q-tabs>
			</div>

			<q-card-section>
				<q-list v-if="loading">
					<q-item
						v-for="(skeleton, index) in skeletons"
						:key="index"
						:class="isMobile ? 'bg-black text-white' : index % 2 === 1 ? 'bg-grey-2' : ''"
					>
						<q-item-section :no-wrap="!isMobile">
							<q-skeleton type="text" :class="isMobile ? 'bg-accent' : ''" />
						</q-item-section>
					</q-item>
				</q-list>
				<q-list v-else>
					<q-item
						v-for="(statement, index) in userStatement"
						:key="index"
						:class="isMobile ? 'bg-black text-white q-mt-md' : index % 2 === 1 ? 'bg-grey-2' : ''"
					>
						<template v-if="isMobile">
							<q-item-section>
								<p>
									<em>{{ $dateUtil.fDateTime(statement.score_date) }}</em>
								</p>
								<p>{{ statement.title }}</p>
							</q-item-section>

							<q-item-section side class="text-white">
								<strong>{{ statement.score }}</strong>
							</q-item-section>
						</template>

						<template v-else>
							<q-item-section avatar>
								{{ $dateUtil.fDateTime(statement.score_date) }}
							</q-item-section>

							<q-item-section>
								{{ statement.title }}
							</q-item-section>

							<q-item-section side>
								{{ statement.score }}
							</q-item-section>
						</template>
						<div v-if="isMobile" class="gojira"></div>
					</q-item>

					<q-item
						v-if="!loading && userStatement.length === 0"
						:class="isMobile ? 'text-white' : 'text-grey-9'"
					>
						<q-item-section class="text-body1">
							{{ $t('you_dont_have_any_points_yet') }}
						</q-item-section>
					</q-item>
				</q-list>
			</q-card-section>
		</q-card-section>
	</q-card>
</template>

<script setup>
import { axios } from 'boot/axios'
import { ref, computed, onMounted, defineProps, getCurrentInstance } from 'vue'
import { useQuasar } from 'quasar'

const props = defineProps({
	close_modal: Function,
	hasCourses: Boolean,
	// hasTrails: Boolean,
	hasPresentials: Boolean,
	hasLiveClasses: Boolean,
	hasWebinars: Boolean,
	hasDrills: Boolean,
	titleCourses: String,
	// titleTrails: String,
	titlePresentials: String,
	titleLiveClasses: String,
	titleWebinars: String,
	titleDrills: String,
})

const $q = useQuasar()
const { ctx } = getCurrentInstance()

const isMobile = computed(() => $q.platform.is.mobile)

const loading = ref(false)
const skeletons = ref([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
const tab = ref('group_trainings')
const userStatement = ref([])

const getUserScoreStatement = async () => {
	loading.value = true

	try {
		const response = await axios.get(
			`etraining_profile/my_profile/get_user_score_statement/?type=${tab.value}`
		)
		userStatement.value = response.data.user_score_statement
	} catch (e) {
		console.log(e)
		$q.notify({
			message: ctx.$t('an_unexpected_error_has_occurred_try_again'),
			type: 'negative',
			icon: 'fal fa-exclamation-triangle',
			position: 'bottom',
		})
	} finally {
		loading.value = false
	}
}

const changeTab = () => {
	userStatement.value = []
	getUserScoreStatement()
}

onMounted(() => {
	if (!props.hasCourses) {
		props.hasPresentials
			? (tab.value = 'presential_events')
			: props.hasWebcasts
			? (tab.value = 'webcasts')
			: props.hasLiveClasses
			? (tab.value = 'live_classes')
			: (tab.value = 'surveys')
	}
	getUserScoreStatement()
})
</script>

<style lang="scss" scoped>
.gorija {
	position: relative;
	display: inline-block;
	padding-bottom: 20px;
}

.gojira:after {
	content: '';
	position: absolute;
	bottom: 10px;
	left: 15%;
	display: inline-block;
	width: 70%;
	border-bottom: 1px solid white;
}
</style>
